// Shared by the server-side prefetch in the course page and by the client-side
// infinite query. The first page is fetched on the server and the rest in the
// browser, so both sides must agree on the page size or pagination overlaps.
export const CONTENT_COMMENTS_PAGE_SIZE = 4;

// The first page arrives with the server rendered page, so it is not refetched
// on mount. Submitting a review triggers an explicit refetch regardless.
export const CONTENT_COMMENTS_CACHE_TIME = 5 * 60 * 1000;

export const contentCommentsQueryKey = (contentType, contentId) => [
	'content-comments',
	contentType,
	contentId
];
